import {
  defineSchema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";

/**
 * Schema for support rules flows.
 * Rules are condition/action flows that automate support ticket handling.
 * They don't use dynamic variables, so this schema is minimal.
 */
export const rulesSchema = defineSchema({
  fields: {
    conversationId: {
      dataType: "Text",
      documentation: "The conversation ID that triggered this rule.",
    },
    teamId: { dataType: "Text", documentation: "The team ID for the rule." },
  },
});

export const exampleRulesSchemaInstance: SchemaInstance<typeof rulesSchema> = {
  conversationId: "conversation-123",
  teamId: "team-123",
};
